import { lazy } from 'react';
import PrincipalPage from '../pages/PrincipalPage/PrincipalPage';
import { Route } from './navigationsinterface';


export const routes: Route[] = [
  {
    path: '/*',
    to: '/*',
    Component: PrincipalPage,
    name: 'Pantalla principal'
  },
  {
    path: '/RecoverReceipt',
    to: '/RecoverReceipt',
    Component:  lazy(() => import('../pages/RecoverReceipt/RecoverReceipt')),
    name: 'Completar pago'
  },
  {
    path: '/Payment/*', 
    to: '/Payment/*',
    Component: lazy(() => import('../pages/Payment/Payment')),
    name: 'Formulario de pago'
  },
  {
    path: '/AdministrationPanel/*', 
    to: '/AdministrationPanel/*',
    Component: lazy(() => import('../pages/AdministrationPanel/AdministrationPanel')),
    name: 'Panel de administración'
  },
  {
    path: '/Login',
    to: '/Login',
    Component: lazy(() => import('../pages/Login/Login')),
    name: 'Login'
  },
];
